fragment NoteFields on Note {
  id
  content
  createdAt
  author {
    id
    fullName
    avatarUrl
  }
}
